import * as THREE from 'three'

/** Procedural board-formed concrete: mottled grey, faint formwork joints and tie holes. One tile covers ~3 m. */
export function makeConcreteTexture(): THREE.CanvasTexture {
  const size = 512
  const canvas = document.createElement('canvas')
  canvas.width = canvas.height = size
  const g = canvas.getContext('2d')!
  g.fillStyle = '#9a968f'
  g.fillRect(0, 0, size, size)

  // Deterministic speckle so the texture is stable between reloads.
  let s = 1234567
  const rand = () => {
    s = (Math.imul(s, 1664525) + 1013904223) >>> 0
    return s / 4294967296
  }
  const img = g.getImageData(0, 0, size, size)
  for (let i = 0; i < img.data.length; i += 4) {
    const n = (rand() - 0.5) * 26
    img.data[i]! += n
    img.data[i + 1]! += n
    img.data[i + 2]! += n
  }
  g.putImageData(img, 0, 0)
  for (let i = 0; i < 160; i++) {
    g.fillStyle = `rgba(${rand() < 0.5 ? '40,38,34' : '230,226,218'},${0.03 + rand() * 0.05})`
    const r = 6 + rand() * 38
    g.beginPath()
    g.ellipse(rand() * size, rand() * size, r, r * (0.4 + rand() * 0.6), rand() * Math.PI, 0, Math.PI * 2)
    g.fill()
  }
  // Formwork joints (panel edges) and tie holes.
  g.strokeStyle = 'rgba(40,38,34,0.55)'
  g.lineWidth = 2
  g.strokeRect(1, 1, size - 2, size - 2)
  g.strokeStyle = 'rgba(40,38,34,0.18)'
  g.lineWidth = 1
  for (const y of [size / 3, (2 * size) / 3]) {
    g.beginPath()
    g.moveTo(0, y)
    g.lineTo(size, y)
    g.stroke()
  }
  g.fillStyle = 'rgba(30,28,25,0.55)'
  for (const [x, y] of [
    [0.25, 0.25],
    [0.75, 0.25],
    [0.25, 0.75],
    [0.75, 0.75],
  ] as const) {
    g.beginPath()
    g.arc(x * size, y * size, 4, 0, Math.PI * 2)
    g.fill()
  }
  const tex = new THREE.CanvasTexture(canvas)
  tex.wrapS = tex.wrapT = THREE.RepeatWrapping
  tex.colorSpace = THREE.SRGBColorSpace
  tex.anisotropy = 8
  return tex
}
